import _, { forEach, get, min } from 'lodash';
import { getOffset } from '../utils/helpers';
import { Datepicker } from 'vanillajs-datepicker';

const Filters = {
	init() {
		// HELPERS

		function getQueryVariable(variable) {
			var query = window.location.search.substring(1);
			var vars = query.split('&');
			for (var i = 0; i < vars.length; i++) {
				var pair = vars[i].split('=');
				if (decodeURIComponent(pair[0]) == variable) {
					return decodeURIComponent(pair[1]);
				}
			}
			//console.log('Query variable %s not found', variable);
		}
		function between(x, min, max) {
			return x >= min && x <= max;
		}
		// Create our number formatter.
		const formatter = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			maximumFractionDigits: 0,
		});
		const _map = document.querySelector('#property-search #map');
		const regionInput = document.querySelector('#region-type');
		var propCount = document.querySelector('#prop-count');
		var propCountWrapper = document.querySelector('.prop-count');
		let _currentRegion = '';
		if (regionInput) {
			_currentRegion = document.querySelector('#region-type').value;
		}
		let url = new URL(window.location.href);

		let active_date = getQueryVariable('availability');
		let affordquery = getQueryVariable('affordable') === 'true' ? true : false;
		let nodate = getQueryVariable('nodate');
		let maxbed = getQueryVariable('maxbed');
		let minbed = getQueryVariable('minbed');
		let maxbath = getQueryVariable('maxbath');
		let minbath = getQueryVariable('minbath');
		let minrent = getQueryVariable('minrent');
		let maxrent = getQueryVariable('maxrent');
		let baths = getQueryVariable('baths');
		let beds = getQueryVariable('beds');
		let sqft = getQueryVariable('sqft');
		let amenities_query_var = url.searchParams.getAll('amenities[]');
		let region_query_var = url.searchParams.getAll('regions[]');
		let propertyid_query_var = url.searchParams.getAll('propertyId[]');

		let map;
		let gmarkers = [];
		//let sqft = 0;
		let region_query = '';
		let amenities_query = '';
		let propID_query = '';
		let min_range_query = '';
		let max_range_query = '';
		let min_bed_query = '';
		let max_bed_query = '';
		let min_bath_query = '';
		let max_bath_query = '';
		let sqft_query = '';
		let fp_request = true;
		let availability_query = '';
		let affordable_query = '';

		if (affordquery) {
			affordquery = '&affordable=true';
		} else {
			affordquery = '';
		}

		if (_currentRegion != 'City' && regionInput) {
			region_query =
				'&regions[]=' +
				document.querySelector('#region-type').dataset.postid;
		}
		async function initMap(props = []) {
			// Request needed libraries.
			const { Map, InfoWindow } = await google.maps.importLibrary('maps');
			const { AdvancedMarkerElement, PinElement } =
				await google.maps.importLibrary('marker');
			const center = {
				lat: 36.3123652,
				lng: -98.7818851,
			};
			let _zoom = 5;
			if (window.innerWidth < 1600) {
				_zoom = 4;
			}
			if (window.innerWidth < 768) {
				_zoom = 3;
			}

			map = new Map(_map, {
				zoom: _zoom,
				center,
				mapId,
				mapTypeControl: false,
				streetViewControl: false,
				fullscreenControl: false,
			});

			google.maps.Map.prototype.panToWithOffset = function (
				latlng,
				offsetX,
				offsetY
			) {
				var map = this;
				var ov = new google.maps.OverlayView();
				ov.onAdd = function () {
					var proj = this.getProjection();
					var aPoint = proj.fromLatLngToContainerPixel(latlng);
					aPoint.x = aPoint.x + offsetX;
					aPoint.y = aPoint.y + offsetY;
					map.panTo(proj.fromContainerPixelToLatLng(aPoint));
				};
				ov.draw = function () { };
				ov.setMap(this);
			};

			const markers = props.map((property, i) => {
				let lat_long = [36.3123652, -98.7818851];
				if (
					property.lat_long != '' &&
					property.lat_long != '0,0' &&
					!property.lat_long.includes('http')
				) {
					lat_long = property.lat_long.replace(/\s/g, '').split(',');
				}

				let position = {
					lat: parseFloat(lat_long[0]),
					lng: parseFloat(lat_long[1]),
				};
				const bluecircle = document.createElement('img');

				bluecircle.src =
					'/wp-content/themes/brookfieldmf/build/img/bluecircle.png';
				bluecircle.style.width = '40px';
				bluecircle.style.height = '40px';

				const marker = new google.maps.marker.AdvancedMarkerElement({
					map,
					position,
					content: bluecircle,
				});
				// const closeCard = marker.content.querySelector('.close-card');
				const infoWindow = new InfoWindow({
					content: buildContent(property),
					disableAutoPan: true,
				});
				marker.addListener('click', (e) => {
					setTimeout(function () {
						map.panToWithOffset(position, 0, -200);
					}, 10);

					infoWindow.open({
						anchor: marker,
						map,
					});
				});

				return marker;
			});
			var options = {
				styles: [
					{
						url: 'https://googlemaps.github.io/js-marker-clusterer/images/m1.png',
						width: 53,
						height: 53,
						textColor: '#fff',
					},
				],
			};
			var markerCluster = new markerClusterer.MarkerClusterer({
				maxZoom: 11,
				zoomOnClick: true,
				map,
				markers,
				options,
			});
		}
		if (_map) {
			initMap(__properties);
			window.addEventListener('resize', () => {
				if (_map) {
					initMap(__properties);
				}
			});
		}

		function buildContent(post) {
			// let content = document.createElement('div');

			// content.classList.add('property-marker');
			let availableUnitsCount = 0;
			if (post.availableUnitsCount) {
				availableUnitsCount = post.unitsCount;
			}
			let _img = '/wp-content/uploads/2024/04/placeholder.jpg';
			if (post.post_featured_image) {
				_img = post.post_featured_image;
			}
			let _price =
				formatter.format(post.minrent) +
				' - ' +
				formatter.format(post.maxrent);
			if (post.minrent == post.maxrent) {
				_price = formatter.format(post.minrent);
			}
			let _is_affordable = getQueryVariable('affordable') === 'true' ? true : false;
			let _nodate = getQueryVariable('nodate');
			let _active_date = getQueryVariable('availability');
			let _maxbed = getQueryVariable('maxbed');
			let _minbed = getQueryVariable('minbed');
			let _maxbath = getQueryVariable('maxbath');
			let _minbath = getQueryVariable('minbath');
			let _minrent = getQueryVariable('minrent');
			let _maxrent = getQueryVariable('maxrent');
			let _beds = getQueryVariable('beds');
			let _baths = getQueryVariable('baths');

			let availquery = '';
			if (_is_affordable) {
				affordquery = '&affordable=true';
			}
			let bedquery = '';
			if (_beds) {
				bedquery = '&beds=' + _beds;
			}
			if (_minbed) {
				bedquery = '&beds=' + _minbed;
			}
			if (_maxbed) {
				bedquery = '&beds=' + _maxbed;
			}
			let bathquery = '';
			if (_baths) {
				bathquery = '&baths=' + _baths;
			}
			if (_minbath) {
				bathquery = 'baths=' + _minbath;
			}
			if (_maxbath) {
				bathquery = 'baths=' + _maxbath;
			}

			if (_active_date) {
				availquery = '&availability=' + _active_date;
			} else {
				const date = new Date();
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');

				let _querydate = `${year}-${month}-${day}`;
				//availquery = '&availability=' + _querydate;
				availquery = '';
			}
			if (_nodate) {
				availquery = '';
			}

			let minrentquery = '';
			let maxrentquery = '';

			if (_minrent) {
				minrentquery = '&minrent=' + _minrent;
			}
			if (_maxrent) {
				maxrentquery = '&maxrent=' + _maxrent;
			}
			let link = '';
			if (post.customAvailabilityURL) {
				link = `${post.customAvailabilityURL}${affordquery}${bedquery}${minrentquery}${maxrentquery}${availquery}`;
			} else {
				link = `/floorplans/?propertyId[]=${post.propertyId}${affordquery}${bedquery}${minrentquery}${maxrentquery}${availquery}`;
			}

			var price_html = '';
			var count_html = '';
			var link_html = 'View Availability';
			var classname = '';
			if (post.maintenance_mode == '1') {
				price_html = `<div class="maintenance_message no_units">
                        <p>Please visit the property page to view property details and a sample of available apartments.</p>
                      </div>
                      <div class="card-cols">
                        <button class="arrow-button" tabindex="-1">
                          <a href="${home_url}/property/${post.post_slug}/">Learn More </a>
                        </button>
                      </div>`;
				classname = 'no-units';
			} else if (_price != '$0') {
				price_html = `<div class="flex">
						<div class="label"><small>Rent Range</small></div>
            <div class="value">${_price}</div>
					</div><button class="arrow-button" aria-label="More Info">
						<a href="${home_url}/property/${post.post_slug}/">Learn More </a> 
					</button>
          <button class="little-blue" aria-label="Availability">
						<a href="${link}">View Availability</a>
					</button>`;
			} else {
				price_html = `<button class="arrow-button" tabindex="-1">
                          <a href="${home_url}/property/${post.post_slug}/">Learn More </a>
                        </button>
                        <button class="little-blue" aria-label="Availability">
													<a href="${home_url}/property/${post.post_slug}/#contact">Call for Pricing</a>
												</button>`;
				link = home_url + '/property/' + post.post_slug + '#contact';
				classname = 'no-units';
			}
			if (availableUnitsCount > 0) {
				count_html = `<div class="label"><small>Available Apartments</small></div>
              <div class="value">${post.unitsCount}</div>`;
				link_html = 'View Availability';
			}
			if (availableUnitsCount > 0) {
				count_html = `<div class="label"><small>Available Apartments</small></div>
              <div class="value">${post.unitsCount}</div>`;
				link_html = 'View Availability3';
			}

			let content = `
			<div class="property-marker highlight">
      <div class="map-card">
			<img src="${_img}" class="image">
        <div class="details ${post.city} ${classname}">
          <p><strong><small>${post.city}, ${post.state}</small></strong></p>
          <div class="title">
            <h3>${post.propertyName}</h3>
          </div>${price_html}
        </div>
      </div> </div>`;

			return content;
		}

		const postContainer = document.querySelector(
			'#property-search #post-container'
		);
		const floorplanPostContainer = document.querySelector(
			'.floorplan-search #post-container'
		);
		const availabilityFilters = document.querySelector(
			'.availability-search'
		);
		async function loadPosts($query, single = false) {
			if (postContainer) {
				postContainer.classList.remove('no-results');
				if (propCountWrapper) {
					propCountWrapper.classList.remove('hide');
				}
				try {
					postContainer.innerHTML =
						'<div></div><div class="spinner"><div></div></div><div></div>';
					let _url =
						home_url +
						`/wp-json/middleware/v1/getProperties?${$query}`;
					if (single) {
						_url =
							home_url +
							`/wp-json/middleware/v1/getProperty?${$query}`;
					} else {
						document.getElementById('select-prop').value = "any";
						propID_query = '';
					}

					const response = await fetch(_url);
					if (!response.ok) {
						throw new Error(
							'Network response was not ok ' + response.statusText
						);
					}
					const posts = await response.json();
					let _properties = posts.filter((property) =>
						[...teir_1, ...teir_2, ...teir_3].includes(
							property.post_id
						)
					);

					postContainer.innerHTML = '';
					if (propCount) {
						propCount.innerHTML = _properties.length;
					}
					if (_map) {
						initMap(_properties);
					}
					window.addEventListener('resize', () => {
						if (_map) {
							initMap(_properties);
						}
					});

					for (const post of _properties) {
						const postElement = document.createElement('div');
						postElement.className = 'card-item ' + post.api;
						let availableUnitsCount = 0;
						if (post.unitsCount) {
							availableUnitsCount = post.unitsCount;
						}
						let _img =
							'/wp-content/uploads/2024/04/placeholder.jpg';
						if (post.post_featured_image) {
							_img = post.post_featured_image;
						}
						let _price =
							formatter.format(post.minrent) +
							' - ' +
							formatter.format(post.maxrent);

						if (post.minrent == post.maxrent) {
							_price = formatter.format(post.minrent);
						}
						let _active_date = getQueryVariable('availability');
						let _maxbed = getQueryVariable('maxbed');
						let _minbed = getQueryVariable('minbed');
						let _maxbath = getQueryVariable('maxbath');
						let _minbath = getQueryVariable('minbath');
						let _minrent = getQueryVariable('minrent');
						let _maxrent = getQueryVariable('maxrent');
						let _beds = getQueryVariable('beds');
						let _baths = getQueryVariable('baths');

						let bedquery = '';
						if (_beds) {
							bedquery = '&beds=' + beds;
						}
						if (_minbed) {
							bedquery = '&beds=' + _minbed;
						}
						if (_maxbed) {
							bedquery = '&beds=' + _maxbed;
						}

						let bathquery = '';
						if (_baths) {
							bathquery = '&baths=' + baths;
						}
						if (_minbath) {
							bathquery = '&baths=' + _minbath;
						}
						if (_maxbath) {
							bathquery = '&baths=' + _maxbath;
						}

						let availquery = '';
						if (_active_date) {
							availquery = '&availability=' + _active_date;
						} else {
							const date = new Date();
							const year = date.getFullYear();
							const month = String(date.getMonth() + 1).padStart(
								2,
								'0'
							);
							const day = String(date.getDate()).padStart(2, '0');

							let _querydate = `${year}-${month}-${day}`;

							availquery = '&availability=' + _querydate;
						}

						let minrentquery = '';
						let maxrentquery = '';

						if (_minrent) {
							minrentquery = '&minrent=' + _minrent;
						}
						if (_maxrent) {
							maxrentquery = '&maxrent=' + _maxrent;
						}

						let link = '';
						if (post.customAvailabilityURL) {
							link = `${post.customAvailabilityURL}${bedquery}${minrentquery}${maxrentquery}${availquery}`;
						} else {
							link = `/floorplans/?propertyId[]=${post.propertyId}${bedquery}${minrentquery}${maxrentquery}${availquery}`;
						}
						let _special = '';
						if (post.special) {
							_special =
								'<div class="is-special">' +
								post.special +
								'</div>';
						}
						var price_html = '';
						var count_html = '';
						var link_html = 'View Availability';
						var classname = '';
						var html = '';
						if (post.maintenance_mode == 1) {
							price_html = `<div class="maintenance_message no_units">
                                    <p>Please visit the property page to view property details and a sample of available apartments.</p>
                                  </div>
                      <div class="card-col">
                <button class="arrow-button" aria-label="Property"> <a href="${home_url}/property/${post.post_slug}/">
                    Learn More </a></button>
              </div>`;
							classname = 'no-units';
						} else if (
							parseInt(post.minrent) <= 0 ||
							!parseInt(post.minrent) ||
							isNaN(parseInt(post.minrent)) ||
							availableUnitsCount == 0
						) {
							price_html = `<div class="card-cols no_units">
                <button class="arrow-button" aria-label="Property"> <a href="${home_url}/property/${post.post_slug}/">
                    Learn More </a></button>
                    <button class="little-blue"  aria-label="Availability"> <a href="${home_url}/property/${post.post_slug}/#contact">Call for Pricing</a></button>
              </div>`;
							classname = 'no-units';
						} else {
							price_html = `<div class="card-cols"><div class="card-col"><div class="label"><small>Rent Range</small></div>
                    <div class="value">${_price}</div>
                <button class="arrow-button" aria-label="Property"> <a href="${home_url}/property/${post.post_slug}/">
                    Learn More </a></button>
                    </div>
                      <div class="card-col"><div class="label"><small>Available Apartments</small></div>
                    <div class="value">${availableUnitsCount}</div>
                <button class="little-blue"  aria-label="Availability"> <a href="${link}">View Availability</a></button>
              </div></div>`;
						}

						postElement.innerHTML = `<img class="image" src="${_img}">${_special}
		            <div class="details ${classname}">
		            <p><strong><small>${post.city}, ${post.state}</small></strong></p>
		            <div class="title">
		            <h3>${post.propertyName}</h3>
		            </div>${price_html}`;
						postContainer.appendChild(postElement);
					}

					// postContainer.insertAdjacentHTML("beforeend", items.join(""));

					// postContainer.appendChild(postElement);
				} catch (error) {
					console.error('Failed to load posts:', error);
					propCount.innerHTML = 0;
					if (_map) {
						initMap();
					}
					postContainer.innerHTML =
						'<div></div> <div style="margin: 100px 0;text-align:center;"><h2 style="margin-bottom:10px;">No results found.</h2><p>Try another date or adjust your search criteria above.</p></div><div></div>';
				}
			}

			if (floorplanPostContainer) {
				if (fp_request) {
					fp_request = false;
					const spinner = document.querySelector('.spinner');
					spinner.classList.remove('hide');
					floorplanPostContainer.innerHTML = '';
					let is_affordable = getQueryVariable('affordable');

					let affordquery = '';
					if (is_affordable) {
						affordquery = '&affordable=true';
					}
					let _url =
						home_url +
						`/wp-json/middleware/v1/getFloorplans?${$query}&has_availability=true&order=DESC${affordquery}`;

					const response = await fetch(_url);
					if (!response.ok) {
						fp_request = true;
						const responseData = await response.json();
						spinner.classList.add('hide');
						propCount.innerHTML = 0;
						document.getElementById('property-name').innerHTML =
							responseData.data.property_name + ' Floor Plans';
						floorplanPostContainer.innerHTML =
							'<div></div><div style="margin: 100px 0;text-align:center;"><h2 style="margin-bottom:10px;">No results found.</h2><p>Try another date or adjust your search criteria above.</p></div><div></div>';

						throw new Error(
							'Network response was not ok ' + response.statusText
						);
					}
					const posts = await response.json();
					spinner.classList.add('hide');
					if (propCountWrapper) {
						propCountWrapper.classList.remove('hide');
					}
					// Check if there are posts
					if (posts.length === 0) {
						loadMoreButton.style.display = 'none';
						return;
					}

					let postElement = '';
					const items = [];
					floorplanPostContainer.innerHTML = '';

					propCount.innerHTML = posts.length;
					for (const post of posts) {
						const postElement = document.createElement('div');
						let unittype = 'Studio';
						if (post.beds == 0) {
							unittype = 'Studio';
						} else if (post.beds == 1) {
							unittype = '1 Bedroom';
						} else if (post.beds == 2) {
							unittype = '2 Bedroom';
						} else if (post.beds == 3) {
							unittype = '3 Bedroom';
						} else if (post.beds == 4) {
							unittype = '4 Bedroom';
						}
						postElement.className = 'card-item';
						postElement.setAttribute('data-beds', post.beds);
						postElement.setAttribute(
							'data-max_price',
							post.min_price
						);
						postElement.setAttribute(
							'data-maximumsqft',
							post.maximumSQFT
						);
						postElement.setAttribute(
							'data-availabledate',
							post.availableDate
						);
						//const _prop = properties.find(prop => prop.post_id === post.post_id);

						let availabilityURL = '';

						availabilityURL =
							'/availabilities/?propertyId[]=' +
							post.parentId +
							'&floorplanId=' +
							post.floorplanId;
						let _img =
							'/wp-content/uploads/2024/04/placeholder.jpg';
						if (post.floorplanImageURL) {
							_img = post.floorplanImageURL;
						}
						let _price =
							formatter.format(post.min_price) +
							' - ' +
							formatter.format(post.max_price);

						if (post.min_price == post.max_price) {
							_price = formatter.format(post.min_price);
						}
						let is_affordable = getQueryVariable('affordable');

						let affordquery = '';
						if (is_affordable) {
							affordquery = '&affordable=true';
						}
						let _active_date = getQueryVariable('availability');
						let avail_query = '';
						if (_active_date) {
							avail_query = '&availability=' + _active_date;
						}
						postElement.innerHTML = `
	            <img src="${_img}" class="image">
	            <div class="details">
	            <p><strong><small>${post.propertyName}</small></strong></p>
	            <h3>${unittype} ${post.floorplanName}</h3>
	            <div class="card-cols">
	                        <div class="card-col">
	                        <div class="label"><small>Rent Range</small></div>
	                          <div class="value">${_price}</div>
	                          ${post.peek_tour ? `
								<button class="arrow-button" aria-label="Property"> 
									<a data-tour="${post.peek_tour}" href="javascript:void(0);" class="fp-tour">
									Virtual Tour </a>
								</button>` : ''}
	                              </div>
	                               <div class="card-col">
	                          <div class="label"><small>Available Apartments</small></div>
	                          <div class="value">${post.unitsCount}</div>
	                          <button class="little-blue" aria-label="Availability"> <a href="${availabilityURL}${affordquery}${avail_query}">
	                              View Availability</a></button>
	                        </div>
	                      </div>`;
						floorplanPostContainer.appendChild(postElement);

						var img = postElement.querySelector('.image');
						img.onload = function () {
							//const _image = postContainer.querySelector('#image-' + post.post_id);
							//postElement.html(this);
						};
						img.addEventListener('error', function (er) {
							this.src =
								home_url +
								'/wp-content/uploads/2024/06/coming-soon-floorplan.jpg';
							console.error('Failed to load image:', er);
						});
						let directory_name = post.post_slug;
						if (_propname) {
							_propname = _propname.replaceAll('-', ' ');
							_propname = _propname.replaceAll('%20', ' ');

							document.getElementById('property-name').innerHTML =
								_propname + ' Floor Plans';
						} else {
							document.getElementById('property-name').innerHTML =
								post.propertyName + ' Floor Plans';
						}
						// document.getElementById('property-name').innerHTML =
						// 	post.propertyName + ' Floor Plans';
						// if (floorplan_directory_name) {
						// 	directory_name = post.floorplan_directory_name;
						// }
						if (post.floorplanImageURL) {
							img.src = post.floorplanImageURL;
						} else {
							let fpname = post.floorplanName.replace(/\s/g, '-');
							fpname = fpname.replace('/', '');
							var jpeg_url =
								'/wp-content/floorplans/' +
								directory_name +
								'/' +
								post.post_slug +
								'-' +
								fpname +
								'.jpg';
							img.src = jpeg_url;
						}
					}
					fp_request = true;
				}
			}

			if (availabilityFilters) {
				const _postContainer =
					document.querySelector('#post-container');

				if (_postContainer) {
					_postContainer.classList.remove('no-results');
				}

				let items = [];
				// if (propertyFilters) {
				// 	items = document.querySelectorAll('.card-item');
				// } else {
				// }
				items = document.querySelectorAll('.list-item');

				$query.replace('?', '');
				let arr = $query.split('&');
				let availability = '';
				let maxbed = '';

				let minrent = '';
				let maxrent = '';
				let squarefeet = '';
				items.forEach((item) => {
					item.classList.remove('hide');
				});
				arr.forEach((qitem) => {
					let attr = qitem.split('=')[0];
					let val = qitem.split('=')[1];
					if (attr == 'availability') {
						availability = val;
					}
					if (attr == 'maxbed') {
						maxbed = parseInt(val);
					}
					if (attr == 'sqft') {
						squarefeet = parseInt(val);
					}
					if (attr == 'maxrent') {
						maxrent = parseInt(val);
					}
					if (attr == 'minrent') {
						minrent = parseInt(val);
					}
				});
				items.forEach((item) => {
					let availableDate = item.dataset.availabledate;
					let _beds = parseInt(item.dataset.beds);
					let max_price = parseInt(item.dataset.max_price);
					let maximumsqft = parseInt(item.dataset.maximumsqft);

					if (availableDate && availability) {
						let availabilityDate = new Date(availability);
						var __day = availabilityDate.getDate() + 2;
						var __month = availabilityDate.getMonth();
						var __year = availabilityDate.getFullYear();
						let mydate = new Date(__year, __month, __day);

						//let mydate = new Date(availability);
						let thisdate = new Date(availableDate);
						if (mydate <= thisdate) {
							item.classList.add('hide');
						}
					}
					if (parseInt(maxbed) >= 0) {
						if (parseInt(maxbed) !== parseInt(_beds)) {
							item.classList.add('hide');
						}
					}
					//console.log(minrent, maxrent, max_price);
					if (max_price && minrent) {
						if (
							maxrent == 'No Max' ||
							maxrent == 'Max' ||
							maxrent == ''
						) {
							maxrent = 100000;
						}
						if (minrent == 'No Min') {
							minrent = 0;
						}
						if (minrent == '') {
							minrent = 0;
						}
						if (
							!between(
								parseInt(max_price),
								parseInt(minrent),
								parseInt(maxrent)
							)
						) {
							item.classList.add('hide');
						}
					}

					if (max_price && maxrent) {
						if (
							maxrent == 'No Max' ||
							maxrent == 'Max' ||
							maxrent == ''
						) {
							maxrent = 100000;
						}
						if (minrent == 'No Min') {
							minrent = 0;
						}
						if (minrent == '') {
							minrent = 0;
						}
						if (
							!between(
								parseInt(max_price),
								parseInt(minrent),
								parseInt(maxrent)
							)
						) {
							item.classList.add('hide');
						}
					}
					if (maximumsqft && squarefeet) {
						if (parseInt(squarefeet) > parseInt(maximumsqft)) {
							item.classList.add('hide');
						}
					}
				});
				// let all_hidden = true;
				let newcount = 0;
				items.forEach((item) => {
					if (!item.classList.contains('hide')) {
						newcount++;
					}
				});
				if (propCount) {
					propCount.innerHTML = newcount;
				}
				const header = document.querySelector(
					'.availability-search-header'
				);
				if (newcount == 0) {
					_postContainer.classList.add('no-results');
					if (header) {
						header.classList.add('hide');
					}
				} else {
					_postContainer.classList.remove('no-results');
					if (header) {
						header.classList.remove('hide');
					}
				}
			}
		}

		//Filters
		var selections = document.querySelector('.property-filter-selections');
		var units = document.querySelector('.property-filter-units');
		var rentrange = document.querySelector('.property-filter-rent-range');
		var avails = document.querySelector('.property-filter-availability');
		var thesqft = document.querySelector('.property-filter-sqft');
		var region = document.querySelector('.property-filter-region');

		var is_over_selections = false;
		var is_over_units = false;
		var is_over_rentrange = false;
		var is_over_availability = false;
		var is_over_thesqft = false;
		var is_over_region = false;
		var sectionwrapper = document.querySelector('.section-wrapper');
		var filterbuttons = document.querySelectorAll(
			'.mobile-filters .filter-button'
		);
		var currentQuery = '';
		var searchProps = document.querySelectorAll('#search-props');
		searchProps.forEach((searchProp) => {
			if (searchProp) {
				searchProp.addEventListener('click', (e) => {
					currentQuery =
						propID_query +
						amenities_query +
						region_query +
						min_bed_query +
						max_bed_query +
						min_bath_query +
						max_bath_query +
						min_range_query +
						max_range_query +
						availability_query +
						sqft_query;
					window.location.href = '/our-communities/?' + currentQuery;
				});
			}
		});

		function myPushState(query) {
			let _query =
				propID_query +
				amenities_query +
				region_query +
				min_bed_query +
				max_bed_query +
				min_bath_query +
				max_bath_query +
				min_range_query +
				max_range_query +
				availability_query +
				affordquery +
				sqft_query;
			let single = false;
			if (query) {
				_query = query;
				single = true;
			}
			// if (postContainer) {
			// 	window.history.pushState('', '', '?' + _query);
			// } else if (floorplanPostContainer) {
			// }
			window.history.pushState('', '', '?' + _query);

			loadPosts(_query, single);
		}
		if (propertyid_query_var.length > 0) {
			propertyid_query_var.forEach((item, index) => {
				propID_query += '&propertyId[]=' + item;
			});

			currentQuery =
				propID_query +
				amenities_query +
				region_query +
				min_bed_query +
				max_bed_query +
				min_bath_query +
				max_bath_query +
				min_range_query +
				max_range_query +
				availability_query +
				affordquery +
				sqft_query;
		}

		if (sqft) {
			sqft_query = '&sqft=' + sqft;
			currentQuery =
				propID_query +
				amenities_query +
				region_query +
				min_bed_query +
				max_bed_query +
				min_bath_query +
				max_bath_query +
				min_range_query +
				max_range_query +
				availability_query +
				affordquery +
				sqft_query;
		}

		if (active_date) {
			const datepicker_inputs =
				document.querySelectorAll('.date-filter input');
			let new_date = active_date;
			let _new_date = new_date.split('-');
			let _month = _new_date[2];
			let _year =
				_new_date[0].length == 1 ? '0' + _new_date[0] : _new_date[0];
			let _day =
				_new_date[1].length == 1 ? '0' + _new_date[1] : _new_date[1];
			new_date = _day + '-' + _month + '-' + _year;
			_new_date = _month + '-' + _day + '-' + _year;

			datepicker_inputs.forEach((datepicker_input) => {
				datepicker_input.value = new_date;
			});
			availability_query = '&availability=' + active_date;
			currentQuery =
				propID_query +
				amenities_query +
				region_query +
				min_bed_query +
				max_bed_query +
				min_bath_query +
				max_bath_query +
				min_range_query +
				max_range_query +
				availability_query +
				affordquery +
				sqft_query;
		} else {
			if (propertyid_query_var.length > 0) {
				const date = new Date();
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				let _querydate = `${year}-${month}-${day}`;
				let __querydate = `${month}-${day}-${year}`;

				const datepicker_inputs =
					document.querySelectorAll('.date-filter input');
				datepicker_inputs.forEach((datepicker_input) => {
					datepicker_input.value = __querydate;
				});

				availability_query = '&availability=' + _querydate;
				currentQuery =
					propID_query +
					amenities_query +
					region_query +
					min_bed_query +
					max_bed_query +
					min_bath_query +
					max_bath_query +
					min_range_query +
					max_range_query +
					availability_query +
					affordquery +
					sqft_query;
			}
		}
		if (nodate) {
			availability_query = '';
			currentQuery =
				propID_query +
				amenities_query +
				region_query +
				min_bed_query +
				max_bed_query +
				min_bath_query +
				max_bath_query +
				min_range_query +
				max_range_query +
				availability_query +
				affordquery +
				sqft_query;
		}
		if (minbed && maxbed) {
			min_bed_query = '&minbed=' + minbed;
			max_bed_query = '&maxbed=' + maxbed;
			if (minbed == 'all') {
				min_bed_query = '';
			}
			if (maxbed == 'all') {
				max_bed_query = '';
			}
			currentQuery =
				propID_query +
				amenities_query +
				region_query +
				min_bed_query +
				max_bed_query +
				min_bath_query +
				max_bath_query +
				min_range_query +
				max_range_query +
				availability_query +
				affordquery +
				sqft_query;
		}
		if (beds) {
			min_bed_query = '&beds=' + beds;
			max_bed_query = '';
			currentQuery =
				propID_query +
				amenities_query +
				region_query +
				min_bed_query +
				max_bed_query +
				min_bath_query +
				max_bath_query +
				min_range_query +
				max_range_query +
				availability_query +
				affordquery +
				sqft_query;
		}
		if (minbath) {
			min_bath_query = '&minbath=' + minbath;
			currentQuery =
				propID_query +
				amenities_query +
				region_query +
				min_bed_query +
				max_bed_query +
				min_bath_query +
				max_bath_query +
				min_range_query +
				max_range_query +
				availability_query +
				affordquery +
				sqft_query;
		}
		if (maxbath) {
			max_bath_query = '&maxbath=' + maxbath;
			currentQuery =
				propID_query +
				amenities_query +
				region_query +
				min_bed_query +
				max_bed_query +
				min_bath_query +
				max_bath_query +
				min_range_query +
				max_range_query +
				availability_query +
				affordquery +
				sqft_query;
		}
		if (baths) {
			max_bath_query = '&baths=' + maxbath;
			currentQuery =
				propID_query +
				amenities_query +
				region_query +
				min_bed_query +
				max_bed_query +
				min_bath_query +
				max_bath_query +
				min_range_query +
				max_range_query +
				availability_query +
				affordquery +
				sqft_query;
		}

		if (minrent) {
			min_range_query = '&minrent=' + minrent;
			currentQuery =
				propID_query +
				amenities_query +
				region_query +
				min_bed_query +
				max_bed_query +
				min_bath_query +
				max_bath_query +
				min_range_query +
				max_range_query +
				availability_query +
				affordquery +
				sqft_query;
		}
		if (maxrent) {
			max_range_query = '&maxrent=' + maxrent;
			currentQuery =
				propID_query +
				amenities_query +
				region_query +
				min_bed_query +
				max_bed_query +
				min_bath_query +
				max_bath_query +
				min_range_query +
				max_range_query +
				availability_query +
				affordquery +
				sqft_query;
		}

		if (amenities_query_var.length > 0) {
			amenities_query_var.forEach((item, index) => {
				amenities_query += '&amenities[]=' + item;
			});
			currentQuery =
				propID_query +
				amenities_query +
				region_query +
				min_bed_query +
				max_bed_query +
				min_bath_query +
				max_bath_query +
				min_range_query +
				max_range_query +
				availability_query +
				affordquery +
				sqft_query;
		}
		if (region_query_var.length > 0) {
			region_query += '&regions[]=' + region_query_var[0];

			currentQuery =
				propID_query +
				amenities_query +
				region_query +
				min_bed_query +
				max_bed_query +
				min_bath_query +
				max_bath_query +
				min_range_query +
				max_range_query +
				availability_query +
				affordquery +
				sqft_query;
			const regionName = document.getElementById(
				'id-' + region_query_var[0]
			);
			if (regionInput && regionName) {
				document.querySelector('#region-type').value =
					regionName.dataset.name;
				document.querySelector('.mobile-filters-wrap .region-filter').textContent = regionName.dataset.name;
			}
		}
		if (currentQuery) {
			loadPosts(currentQuery);
		}

		// var datefilters = document.querySelectorAll('.date-filter');
		// datefilters.forEach((datefilter) => {
		// 	datefilter.addEventListener('click', (event) => {
		// 		datefilter.classList.toggle('active');
		// 	});
		// });
		function resetOpenMods(el) {
			if (!is_over_selections && selections) {
				selections.classList.add('hide');
			}
			if (!is_over_units && units) {
				units.classList.add('hide');
			}
			if (!is_over_rentrange && rentrange) {
				rentrange.classList.add('hide');
			}
			if (!is_over_availability && avails) {
				avails.classList.add('hide');
			}
			if (!is_over_thesqft && thesqft) {
				thesqft.classList.add('hide');
			}
			if (!is_over_region && region) {
				region.classList.add('hide');
			}
		}
		if (sectionwrapper) {
			sectionwrapper.addEventListener('click', (e) => {
				if (!is_over_selections && selections) {
					selections.classList.add('hide');
				}
				if (!is_over_units && units) {
					units.classList.add('hide');
				}
				if (!is_over_rentrange && rentrange) {
					rentrange.classList.add('hide');
				}
				if (!is_over_availability && avails) {
					avails.classList.add('hide');
				}
				if (!is_over_thesqft && thesqft) {
					thesqft.classList.add('hide');
				}
				if (!is_over_region && region) {
					region.classList.add('hide');
				}
				//e.preventDefault();
			});
		}

		if (selections) {
			var amenities_actions = selections.querySelectorAll(
				'.actions-amenities .action'
			);
			if (amenities_actions) {
				if (amenities_query_var) {
					amenities_query_var.forEach((item, index) => {
						item = item.replace('"', '');
						item = item.replace('"', '');
						item = item.replace('%20', ' ');
						let _action = selections.querySelector(
							'[data-amenityname="' + item + '"]'
						);
						_action.classList.add('active');
						_action.querySelector('input').checked = true;

						amenities_query += '&amenities[]=' + item;
					});
				}

				amenities_actions.forEach((action, index) => {
					var input = action.querySelector('input');
					input.addEventListener('click', (e) => {
						e.preventDefault();
					});
					if (input) {
						let _newname = JSON.stringify(input.name);
						_newname = _newname.replace('"', '');
						_newname = _newname.replace('"', '');
						var index = '&amenities[]=' + _newname;
						action.addEventListener('click', (e) => {
							if (action.classList.contains('active')) {
								action.classList.remove('active');
								action.querySelector('input').checked = false;
								amenities_query = amenities_query.replace(
									index,
									''
								);
							} else {
								action.classList.add('active');
								action.querySelector('input').checked = true;
								if (!amenities_query.includes(index)) {
									amenities_query += index;
								}
							}

							myPushState();
						});
					}
				});
			}

			selections.addEventListener('mouseover', (e) => {
				is_over_selections = true;
			});
			selections.addEventListener('mouseout', (e) => {
				is_over_selections = false;
			});

			var allfilters = document.querySelector('.all-filters');
			if (allfilters) {
				allfilters.addEventListener('click', (event) => {
					resetOpenMods();
					if (allfilters.classList.contains('active')) {
						allfilters.classList.remove('active');
						selections.classList.add('hide');
					} else {
						allfilters.classList.add('active');
						selections.classList.remove('hide');
					}

					event.stopPropagation();
				});
				var clear = selections.querySelector('.clear');
				var resetDate = '';
				clear.addEventListener('click', (e) => {
					regionInput.value = 'City';
					document.querySelector('#rent-range').value = 'Any - Any';
					document.querySelector('#datepicker').value = 'Select Date';
					document.querySelector('#unit-type').value = 'Any';
					var actions = document.querySelectorAll('.action');
					if (postContainer) {
						postContainer.classList.remove('no-results');
					}
					if (actions) {
						actions.forEach((action) => {
							action.classList.remove('active');
							if (action.querySelector('input')) {
								action.querySelector('input').checked = false;
							}
							if (action.classList.contains('id-bed-any')) {
								action.classList.add('active');
								if (action.querySelector('input')) {
									action.querySelector('input').checked =
										true;
								}
							}
							if (action.classList.contains('id-bath-any')) {
								action.classList.add('active');
								if (action.querySelector('input')) {
									action.querySelector('input').checked =
										true;
								}
							}
						});
						const date = new Date();
						const year = date.getFullYear();
						const month = String(date.getMonth() + 1).padStart(
							2,
							'0'
						);
						const day = String(date.getDate()).padStart(2, '0');
						resetDate = `${year}-${month}-${day}`;
					}
					var selects = selections.querySelectorAll('select');
					selects.forEach((element) => {
						element.value = 'any';
					});
					const datepicker_inputs =
						document.querySelectorAll('.date-filter input');
					datepicker_inputs.forEach((datepicker_input) => {
						datepicker_input.value = 'Select Date';
					});

					amenities_query = '';
					region_query = '';
					min_bed_query = '';
					max_bed_query = '';
					min_bath_query = '';
					max_bath_query = '';
					min_range_query = '';
					max_range_query = '';
					availability_query = '';
					sqft_query = '';
					selections.classList.add('hide');
					myPushState();
				});
				var done = selections.querySelector('.done');
				done.addEventListener('click', (e) => {
					selections.classList.add('hide');
				});
			}
			var property_select_actions =
				document.getElementById('select-prop');
			if (property_select_actions) {
				property_select_actions.addEventListener('change', (e) => {
					// propID_query = 'propertyId=' + e.target.value;
					amenities_query = '';
					region_query = '';
					min_bed_query = '';
					max_bed_query = '';
					min_bath_query = '';
					max_bath_query = '';
					min_range_query = '';
					max_range_query = '';
					availability_query = '';
					sqft_query = '';
					loadPosts('propertyId=' + e.target.value, true);
					selections.classList.add('hide');
					regionInput.value = 'City';
					document.querySelector('#rent-range').value = 'Any - Any';
					document.querySelector('#datepicker').value = 'Select Date';
					document.querySelector('#unit-type').value = 'Any';
					const datepicker_inputs =
						document.querySelectorAll('.date-filter input');
					datepicker_inputs.forEach((datepicker_input) => {
						datepicker_input.value = 'Select Date';
					});
					var actions = document.querySelectorAll('.action');
					if (actions) {
						actions.forEach((action) => {
							action.classList.remove('active');
							if (action.querySelector('input')) {
								action.querySelector('input').checked = false;
							}
							if (action.classList.contains('id-bed-any')) {
								action.classList.add('active');
								if (action.querySelector('input')) {
									action.querySelector('input').checked =
										true;
								}
							}
						});
					}
					const newUrl = window.location.origin + window.location.pathname;
					// Update the browser's address bar without reloading the page
					window.history.pushState({}, document.title, newUrl);
				});
			}
		}
		var unittypefilters = document.querySelectorAll('.units-filter');
		if (units) {
			let _actions = document.querySelectorAll(
				'.actions-bedrooms .action'
			);
			if (_actions) {
				if (minbed && minbed != 'all') {
					_actions.forEach((action) => {
						action.classList.remove('active');
						action.querySelector('input').checked = false;
					});
					let _act = document.querySelectorAll('.id-bed-' + minbed);
					_act.forEach((act) => {
						act.classList.add('active');
						act.querySelector('input').checked = true;
						var bedText = "";
						if (act.getAttribute("id") == "beds-0") {
							bedText = "Studio";
						} else if (act.getAttribute("id") == "beds-1") {
							bedText = "1 Bedroom";
						} else if (act.getAttribute("id") == "beds-2") {
							bedText = "2 Bedroom";
						} else if (act.getAttribute("id") == "beds-3") {
							bedText = "3 Bedroom";
						} else {
							bedText = "Any";
						}
						document.querySelector('.mobile-filters-wrap .units-filter').textContent = bedText;
					});
					min_bed_query = '&minbed=' + minbed;
					if (minbed == 'all') {
						min_bed_query = '';
					}
				}
				console.log('maxbed' + maxbed);
				if (maxbed && maxbed != 'all') {
					console.log('minbed' + minbed);
					_actions.forEach((action) => {
						action.classList.remove('active');
						action.querySelector('input').checked = false;
					});
					let _act = document.querySelectorAll('.id-bed-' + minbed);
					_act.forEach((act) => {
						act.classList.add('active');
						act.querySelector('input').checked = true;
					});
					max_bed_query = '&maxbed=' + maxbed;
					if (maxbed == 'all') {
						max_bed_query = '';
					}
				} else if (beds) {
					_actions.forEach((action) => {
						action.classList.remove('active');
						action.querySelector('input').checked = false;
					});
					let _act = document.querySelectorAll('.id-bed-' + beds);
					_act.forEach((act) => {
						act.classList.add('active');
						act.querySelector('input').checked = true;
					});

				}
				if (minbed == 0 || maxbed == 0 || beds == 0) {
					document.querySelector('#unit-type').value = 'Studio';
				}
				if (minbed == 1 || maxbed == 1 || beds == 1) {
					document.querySelector('#unit-type').value = '1 Bedroom';
				}
				if (minbed == 2 || maxbed == 2 || beds == 2) {
					document.querySelector('#unit-type').value = '2 Bedroom';
				}
				if (minbed == 3 || maxbed == 3 || beds == 3) {
					document.querySelector('#unit-type').value = '3 Bedroom';
				}
				_actions.forEach((action) => {
					var input = action.querySelector('input');
					input.addEventListener('click', (e) => {
						e.preventDefault();
					});
					if (input) {
						action.addEventListener('click', (e) => {
							_actions.forEach((act) => {
								act.classList.remove('active');
								act.querySelector('input').checked = false;

								if (act.id == action.id) {
									act.classList.add('active');
									act.querySelector('input').checked = true;
								}
							});

							action.classList.add('active');
							action.querySelector('input').checked = true;
							if (action.id == 'beds-any') {
								min_bed_query = '';
								max_bed_query = '';
								document.querySelector('#unit-type').value =
									'Any';
							}
							if (action.id == 'beds-0') {
								if (floorplanPostContainer) {
									min_bed_query = '&beds=0';
									max_bed_query = '';
								} else {
									min_bed_query = '&minbed=0';
									max_bed_query = '&maxbed=0';
								}
								document.querySelector('#unit-type').value =
									'Studio';
							}
							if (action.id == 'beds-1') {
								if (floorplanPostContainer) {
									min_bed_query = '&beds=1';
									max_bed_query = '';
								} else {
									min_bed_query = '&minbed=1';
									max_bed_query = '&maxbed=1';
								}
								document.querySelector('#unit-type').value =
									'1 Bedroom';
							}
							if (action.id == 'beds-2') {
								if (floorplanPostContainer) {
									min_bed_query = '&beds=2';
									max_bed_query = '';
								} else {
									min_bed_query = '&minbed=2';
									max_bed_query = '&maxbed=2';
								}
								document.querySelector('#unit-type').value =
									'2 Bedroom';
							}
							if (action.id == 'beds-3') {
								if (floorplanPostContainer) {
									min_bed_query = '&beds=3';
									max_bed_query = '';
								} else {
									min_bed_query = '&minbed=3';
									max_bed_query = '&maxbed=3';
								}
								document.querySelector('#unit-type').value =
									'3 Bedroom';
							}
							var bedText = "";
							if (action.getAttribute("id") == "beds-0") {
								bedText = "Studio";
							} else if (action.getAttribute("id") == "beds-1") {
								bedText = "1 Bedroom";
							} else if (action.getAttribute("id") == "beds-2") {
								bedText = "2 Bedroom";
							} else if (action.getAttribute("id") == "beds-3") {
								bedText = "3 Bedroom";
							} else {
								bedText = "Any";
							}
							document.querySelector('.mobile-filters-wrap .units-filter').textContent = bedText;
							myPushState();
						});
					}
				});
			}
			if (unittypefilters.length > 0) {
				units.addEventListener('mouseover', (e) => {
					is_over_units = true;
				});
				units.addEventListener('mouseout', (e) => {
					is_over_units = false;
				});
				unittypefilters.forEach((unittypefilter) => {
					unittypefilter.addEventListener('click', (event) => {
						resetOpenMods();
						filterbuttons.forEach((button) => {
							button.classList.remove('active');
						});
						if (unittypefilter.classList.contains('active')) {
							unittypefilter.classList.remove('active');
							units.classList.add('hide');
						} else {
							unittypefilter.classList.add('active');
							units.classList.remove('hide');
						}

						event.stopPropagation();
					});
				});
				var clear = units.querySelector('.clear');
				clear.addEventListener('click', (e) => {
					if (postContainer) {
						postContainer.classList.remove('no-results');
					}
					units.querySelectorAll('.action').forEach((e, i) => {
						e.classList.remove('active');
						if (i == 0) {
							e.classList.add('active');
						}
					});
					unittypefilters.forEach((unittypefilter) => {
						unittypefilter.classList.remove('active');
					});
					min_bed_query = '';
					max_bed_query = '';
					document.querySelector('#unit-type').value = 'Any';
					document.querySelector('.mobile-filters-wrap .units-filter').textContent = "Any";
					units.classList.add('hide');

					myPushState();
				});
				var done = units.querySelector('.done');
				done.addEventListener('click', (e) => {
					units.classList.add('hide');
					unittypefilters.forEach((unittypefilter) => {
						unittypefilter.classList.remove('active');
					});
				});
			}
		}

		// BATH

		let bath_actions = document.querySelectorAll(
			'.actions-bathrooms .action'
		);
		if (bath_actions.length > 0) {
			if (minbath) {
				let _act = document.querySelectorAll('.id-bath-' + minbath);
				_act.forEach((act) => {
					act.classList.add('active');
					act.querySelector('input').checked = true;
				});
				if (floorplanPostContainer) {
					min_bath_query = '&baths=' + minbath;
					max_bath_query = '';
				} else {
					min_bath_query = '&minbath=' + minbath;
				}
			}
			if (maxbath) {
				let _act = document.querySelectorAll('.id-bath-' + minbath);
				_act.forEach((act) => {
					act.classList.add('active');
					act.querySelector('input').checked = true;
				});
				if (floorplanPostContainer) {
					min_bath_query = '';
					max_bath_query = '&baths=' + maxbath;
				} else {
					max_bath_query = '&maxbath=' + maxbath;
				}
			}

			bath_actions.forEach((action) => {
				var input = action.querySelector('input');
				input.addEventListener('click', (e) => {
					e.preventDefault();
				});
				if (input) {
					action.addEventListener('click', (e) => {
						bath_actions.forEach((act) => {
							act.classList.remove('active');
							act.querySelector('input').checked = false;

							if (act.id == action.id) {
								act.classList.add('active');
								act.querySelector('input').checked = true;
							}
						});

						if (action.id == 'bath-any') {
							min_bath_query = '';
							max_bath_query = '';
						}
						if (action.id == 'bath-0') {
							if (floorplanPostContainer) {
								min_bath_query = '&baths=0';
								max_bath_query = '';
							} else {
								min_bath_query = '&minbath=0';
								max_bath_query = '&maxbath=0';
							}
						}
						if (action.id == 'bath-1') {
							if (floorplanPostContainer) {
								min_bath_query = '&baths=1';
								max_bath_query = '';
							} else {
								min_bath_query = '&minbath=1';
								max_bath_query = '&maxbath=1';
							}
						}
						if (action.id == 'bath-2') {
							if (floorplanPostContainer) {
								min_bath_query = '&baths=2';
								max_bath_query = '';
							} else {
								min_bath_query = '&minbath=2';
								max_bath_query = '&maxbath=2';
							}
						}
						if (action.id == 'bath-3') {
							if (floorplanPostContainer) {
								min_bath_query = '&baths=3';
								max_bath_query = '';
							} else {
								min_bath_query = '&minbath=3';
								max_bath_query = '&maxbath=3';
							}
						}
						myPushState();
					});
				}
			});
		}
		const datepickers = document.querySelectorAll('.calender-selector');
		if (datepickers.length > 0) {
			let currentDate = new Date();
			var __day = currentDate.getDate() + 90;
			var __month = currentDate.getMonth();
			var __year = currentDate.getFullYear();
			let threeMonths = new Date(__year, __month, __day);
			forEach(datepickers, (el) => {
				const _datepicker = new Datepicker(el, {
					format: 'yyyy-mm-dd',
					minDate: currentDate,
					maxDate: threeMonths,
					clearButton: true,
					todayButton: false,
				});

				if (active_date) {
					_datepicker.setDate(active_date);
					_datepicker.update();
					const date = new Date(active_date);
					const year = date.getFullYear();
					const month = String(date.getMonth() + 1).padStart(2, '0');
					const day = String(date.getDate()).padStart(2, '0');
					el.value = `${year}-${month}-${day}`;
				}
				const datepicker_inputs =
					document.querySelectorAll('.date-filter input');

				el.addEventListener('changeDate', (e) => {
					datepicker_inputs.forEach((datepicker_input) => {
						active_date = _datepicker.getDate('yyyy-mm-dd');
						let _active_date = _datepicker.getDate('mm-dd-yyyy');
						if (
							active_date != '' &&
							active_date != undefined &&
							active_date != 'undefined'
						) {
							availability_query = '&availability=' + active_date;
							datepicker_input.value = _active_date;
						} else {
							availability_query = '';
							datepicker_input.value = 'Select Date';

							if (avails) {
								avails.classList.add('hide');
								var availabilityfilters =
									document.querySelectorAll('.date-filter');
								availabilityfilters.forEach(
									(availabilityfilter) => {
										availabilityfilter.classList.remove(
											'active'
										);
									}
								);
							}
						}
					});
					myPushState();
				});
				const _clear = avails.querySelector('.clear-button');
				_clear.addEventListener('click', (e) => {
					availability_query = '';
					datepicker_inputs.forEach((datepicker_input) => {
						datepicker_input.value = 'Select Date';
					});
					if (avails) {
						avails.classList.add('hide');
						var availabilityfilters =
							document.querySelectorAll('.date-filter');
						availabilityfilters.forEach((availabilityfilter) => {
							availabilityfilter.classList.remove('active');
						});
					}
					myPushState();
				});
				const _done = avails.querySelector('.done');
				_done.addEventListener('click', (e) => {
					if (avails) {
						avails.classList.add('hide');
						var availabilityfilters =
							document.querySelectorAll('.date-filter');
						availabilityfilters.forEach((availabilityfilter) => {
							availabilityfilter.classList.remove('active');
						});
					}
				});
			});
		}
		if (avails) {
			avails.addEventListener('mouseover', (e) => {
				is_over_availability = true;
			});
			avails.addEventListener('mouseout', (e) => {
				is_over_availability = false;
			});
			var availabilityfilters = document.querySelectorAll('.date-filter');
			availabilityfilters.forEach((availabilityfilter) => {
				availabilityfilter.addEventListener('click', (event) => {
					resetOpenMods();
					filterbuttons.forEach((button) => {
						button.classList.remove('active');
					});
					if (availabilityfilter.classList.contains('active')) {
						availabilityfilter.classList.remove('active');
						avails.classList.add('hide');
					} else {
						availabilityfilter.classList.add('active');
						avails.classList.remove('hide');
					}

					event.stopPropagation();
				});
			});
		}

		if (rentrange) {
			if (minrent) {
				let _minText = '';
				if (minrent == '' || minrent == undefined) {
					_minText = 'No Min';
				} else {
					_minText = formatter.format(minrent);
				}

				let _maxText = '';
				if (maxrent == 'Max') {
					_maxText = 'Max';
				} else if (maxrent == 'No Max' || maxrent == undefined) {
					_maxText = 'Any';
				} else {
					_maxText = formatter.format(maxrent);
				}

				document.querySelector('#rent-range').value =
					_minText + ' - ' + _maxText;
				document.querySelector('.mobile-filters-wrap .range-filter').textContent = _minText + ' - ' + _maxText;
				min_range_query = '&minrent=' + minrent;
			}
			if (maxrent) {
				let _minText = '';
				if (minrent == '' || minrent == undefined) {
					_minText = 'No Min';
				} else {
					_minText = formatter.format(minrent);
				}

				let _maxText = '';

				if (maxrent == 'Max') {
					_maxText = 'Max';
				} else if (maxrent == 'No Max' || maxrent == undefined) {
					_maxText = 'Any';
				} else {
					_maxText = formatter.format(maxrent);
				}

				document.querySelector('#rent-range').value =
					_minText + ' - ' + _maxText;
				document.querySelector('.mobile-filters-wrap .range-filter').textContent = _minText + ' - ' + _maxText;
				if (maxrent == 'Max' || maxrent == 'No Max') {
					max_range_query = '';
				} else {
					max_range_query = '&maxrent=' + maxrent;
				}
			}
			rentrange
				.querySelectorAll('.range-actions .action')
				.forEach((action) => {
					action.classList.remove('active');
					if (minrent && action.dataset.minnum == minrent) {
						action.classList.add('active');
					}
					if (maxrent && action.dataset.maxnum == maxrent) {
						action.classList.add('active');
					}

					action.addEventListener('click', (e) => {
						var topvalue =
							document.querySelector('#rent-range').value;

						const words = topvalue.split(' - ');

						//action.querySelector('input').checked = true;
						if (action.dataset.minnum) {
							rentrange
								.querySelectorAll('.min-actions .action')
								.forEach((e) => {
									e.classList.remove('active');
								});
							if (action.dataset.minnum == 'No Min') {
								min_range_query = '';
								document.querySelector('#rent-range').value =
									'No Min' + ' - ' + words[1];
								document.querySelector('.mobile-filters-wrap .range-filter').textContent = 'No Min' + ' - ' + words[1];
							} else {
								min_range_query =
									'&minrent=' + action.dataset.minnum;
								document.querySelector('#rent-range').value =
									formatter.format(action.dataset.minnum) +
									' - ' +
									words[1];
								document.querySelector('.mobile-filters-wrap .range-filter').textContent = formatter.format(action.dataset.minnum) + ' - ' + words[1];
							}
							if (words[1] == 'Max' || words[1] == 'No Max') {
								max_range_query = '';
							}
						}

						if (action.dataset.maxnum) {
							let _maxText = '';
							rentrange
								.querySelectorAll('.max-actions .action')
								.forEach((e) => {
									e.classList.remove('active');
								});

							if (action.dataset.maxnum == 'Max') {
								_maxText = 'Max';
								max_range_query = '';
								document.querySelector('#rent-range').value =
									words[0] + ' - Max';
								document.querySelector('.mobile-filters-wrap .range-filter').textContent = words[0] + ' - Max';
							} else if (
								action.dataset.maxnum == 'No Max' ||
								action.dataset.maxnum == undefined
							) {
								max_range_query = '';
								document.querySelector('#rent-range').value =
									words[0] + ' - Any';
								document.querySelector('.mobile-filters-wrap .range-filter').textContent = words[0] + ' - Any';
							} else {
								_maxText = formatter.format(
									action.dataset.maxnum
								);
								max_range_query =
									'&maxrent=' + action.dataset.maxnum;
								document.querySelector('#rent-range').value =
									words[0] + ' - ' + _maxText;
								document.querySelector('.mobile-filters-wrap .range-filter').textContent = words[0] + ' - ' + _maxText;
							}

							if (words[0] == 'No Min') {
								min_range_query = '';
							}
						}
						rentrangefilters.forEach((rentrangefilter) => {
							rentrangefilter.classList.remove('active');
						});

						action.classList.add('active');

						myPushState();
					});
				});

			var rentrangefilters = document.querySelectorAll('.range-filter');
			if (rentrangefilters.length > 0) {
				rentrange.addEventListener('mouseover', (e) => {
					is_over_units = true;
				});
				rentrange.addEventListener('mouseout', (e) => {
					is_over_units = false;
				});
				// var clearFilter = false;
				rentrangefilters.forEach((rentrangefilter) => {
					rentrangefilter.addEventListener('click', (event) => {
						filterbuttons.forEach((button) => {
							button.classList.remove('active');
						});
						resetOpenMods();

						if (event.target.classList.contains('active')) {
							event.target.classList.remove('active');
							rentrange.classList.add('hide');
						} else {
							event.target.classList.add('active');
							rentrange.classList.remove('hide');
						}

						event.stopPropagation();
					});
					var done = rentrange.querySelector('.done');
					done.addEventListener('click', (e) => {
						rentrange.classList.add('hide');
						rentrangefilters.forEach((rentrangefilter) => {
							rentrangefilter.classList.remove('active');
						});
					});
				});
				var clear = rentrange.querySelector('.clear');
				clear.addEventListener('click', (e) => {
					if (postContainer) {
						postContainer.classList.remove('no-results');
					}
					max_range_query = '';
					min_range_query = '';
					myPushState();
					rentrange
						.querySelectorAll('.range-actions .action')
						.forEach((action) => {
							action.classList.remove('active');
						});
					document.querySelector('#rent-range').value =
						'Any' + ' - ' + 'Any';
					document.querySelector('.mobile-filters-wrap .range-filter').textContent = 'Any' + ' - ' + 'Any';
					rentrange.classList.add('hide');
					rentrangefilters.forEach((rentrangefilter) => {
						rentrangefilter.classList.remove('active');
					});
				});
			}
		}

		if (thesqft) {
			const allactions = thesqft.querySelectorAll(
				'.sqft-actions .action'
			);
			allactions.forEach((action) => {
				action.addEventListener('click', (e) => {
					allactions.forEach((act) => {
						act.classList.remove('active');
					});
					//var topvalue = document.querySelector('#sqr-footage').value;
					thesqft.querySelectorAll('.sqft-actions .action');

					//action.querySelector('input').checked = true;
					if (action.dataset.sqft) {
						let name = action.dataset.sqft;
						if (action.dataset.sqft == 0) {
							name = 'Any';
						}
						sqft_query = '&sqft=' + action.dataset.sqft;
						document.querySelector('#sqr-footage').value = name;
						thesqft
							.querySelectorAll('.min-actions .action')
							.forEach((e) => {
								e.classList.remove('active');
							});
					}

					action.classList.add('active');

					myPushState();
				});
			});

			var sqftfilters = document.querySelectorAll('.sqft-filter');
			if (sqftfilters.length > 0) {
				thesqft.addEventListener('mouseover', (e) => {
					is_over_thesqft = true;
				});
				thesqft.addEventListener('mouseout', (e) => {
					is_over_thesqft = false;
				});
				sqftfilters.forEach((sqftfilter) => {
					sqftfilter.addEventListener('click', (event) => {
						resetOpenMods();
						filterbuttons.forEach((button) => {
							button.classList.remove('active');
						});
						sqftfilter.classList.toggle('active');
						thesqft.classList.remove('hide');

						event.stopPropagation();
					});
				});
				var clear = thesqft.querySelector('.clear');
				clear.addEventListener('click', (e) => {
					if (postContainer) {
						postContainer.classList.remove('no-results');
					}
					sqft_query = '';
					myPushState();
					thesqft.classList.add('hide');
					thesqft
						.querySelectorAll('.sqft-actions .action')
						.forEach((action) => {
							action.classList.remove('active');
						});
					document.querySelector('#sqr-footage').value = 'Any';
				});
				var done = thesqft.querySelector('.done');
				done.addEventListener('click', (e) => {
					thesqft.classList.add('hide');
				});
			}
		}

		var regionfilters = document.querySelectorAll('.region-filter');
		if (regionfilters.length > 0 && region) {
			var _actions = document.querySelectorAll(
				'.actions-regions .action'
			);
			if (_actions) {
				if (region_query_var) {
					region_query_var.forEach((item, index) => {
						let _actions = document.querySelectorAll('.id-' + item);
						_actions.forEach((act) => {
							act.classList.add('active');
							act.querySelector('input').checked = true;
							if (document.querySelector('.mobile-filters-wrap .region-filter')) {
								document.querySelector('.mobile-filters-wrap .region-filter').textContent = act.getAttribute("data-name");
							}
						});
						region_query = '&regions[]=' + item;
					});
				}
				_actions.forEach((action) => {
					var input = action.querySelector('input');
					input.addEventListener('click', (e) => {
						e.preventDefault();
					});
					if (input) {
						var index =
							'&regions[]=' + action.id.replace('id-', '');
						action.addEventListener('click', (e) => {
							document.querySelector('#region-type').value =
								action.dataset.name;
							if (document.querySelector('.mobile-filters-wrap .region-filter')) {
								document.querySelector('.mobile-filters-wrap .region-filter').textContent = action.dataset.name;
							}
							_actions.forEach((act) => {
								if (act.id == action.id) {
									act.classList.add('active');
									act.querySelector('input').checked = true;
									if (document.querySelector('.mobile-filters-wrap .region-filter')) {
										document.querySelector('.mobile-filters-wrap .region-filter').textContent = act.getAttribute("data-name");
									}
								} else {
									act.classList.remove('active');
									act.querySelector('input').checked = false;
								}
							});
							action.classList.add('active');
							action.querySelector('input').checked = true;

							if (region_query != index) {
								region_query = index;
							}

							myPushState();
							region.classList.add('hide');
							regionfilters.forEach((regionfilter) => {
								regionfilter.classList.remove('active');
							});
						});
					}
				});
			}
			region.addEventListener('mouseover', (e) => {
				is_over_region = true;
			});
			region.addEventListener('mouseout', (e) => {
				is_over_region = false;
			});
			regionfilters.forEach((regionfilter) => {
				regionfilter.addEventListener('click', (event) => {
					resetOpenMods();
					filterbuttons.forEach((button) => {
						button.classList.remove('active');
					});
					if (regionfilter.classList.contains('active')) {
						region.classList.add('hide');
						regionfilter.classList.remove('active');
					} else {
						event.target.classList.add('active');
						region.classList.remove('hide');
						regionfilter.classList.add('active');
					}

					event.stopPropagation();
				});
				var clear = region.querySelector('.clear');
				clear.addEventListener('click', (e) => {
					if (postContainer) {
						postContainer.classList.remove('no-results');
					}
					var actions = region.querySelectorAll('.action');
					if (actions) {
						actions.forEach((action) => {
							action.classList.remove('active');
							action.querySelector('input').checked = false;
						});
					}
					var regionActions = document.querySelectorAll(
						'.actions-regions .action'
					);
					regionfilter.classList.remove('active');
					if (regionActions.length > 0) {
						regionActions.forEach((action) => {
							action.classList.remove('active');
							action.querySelector('input').checked = false;
						});
					}
					var selects = region.querySelectorAll('select');
					selects.forEach((element) => {
						element.value = 'any';
					});
					region_query = '';
					document.querySelector('#region-type').value = 'City';
					region.classList.add('hide');
					myPushState();
					document.querySelector('.mobile-filters-wrap .region-filter').textContent = "Greater Region";
				});
				var done = region.querySelector('.done');
				done.addEventListener('click', (e) => {
					region.classList.add('hide');
					regionfilter.classList.remove('active');
				});
			});
		}
		const viewSwappers = document.querySelectorAll('.view-swapper');
		const mobileswitch = document.querySelector('.mobile-view');
		const propertysearch = document.querySelector('#property-search');
		const floorplanslider = document.querySelector('#floorplan-slider');
		const wrapper = document.querySelector('#tabbed-galleries');
		if (viewSwappers) {
			viewSwappers.forEach((viewSwapper) => {
				const switcher = viewSwapper.querySelector('.switch input');
				viewSwapper.addEventListener('click', function () {
					if (propertysearch) {
						if (switcher.checked == true) {
							switcher.checked = false;
							propertysearch.classList.remove('show-map');
							if(mobileswitch){
								mobileswitch.classList.remove('show-map');
							}
						} else {
							switcher.checked = true;
							propertysearch.classList.add('show-map');
							if(mobileswitch){
								mobileswitch.classList.add('show-map');
							}
						}
					}
					if (wrapper) {
						if (wrapper.classList.contains('show-sliders')) {
							wrapper.classList.remove('show-sliders');
						} else {
							wrapper.classList.add('show-sliders');
						}
					}
					if (floorplanslider) {
						if (switcher.checked == true) {
							switcher.checked = false;
							floorplanslider.classList.remove('show-map');
						} else {
							switcher.checked = true;
							floorplanslider.classList.add('show-map');
						}
					}
				});
			});
		}

		if (mobileswitch) {
			mobileswitch.addEventListener('click', function () {
				if (!mobileswitch.classList.contains('show-map')) {
					propertysearch.classList.add('show-map');
					mobileswitch.classList.add('show-map');
					if (viewSwappers) {
						viewSwappers.forEach((viewSwapper) => {
							viewSwapper.querySelector('.switch input').checked =
								true;
						});
					}
					propertysearch.classList.add('show-map');
				} else {
					propertysearch.classList.remove('show-map');
					mobileswitch.classList.remove('show-map');
					if (viewSwappers) {
						viewSwappers.forEach((viewSwapper) => {
							viewSwapper.querySelector('.switch input').checked =
								false;
						});
					}
					propertysearch.classList.remove('show-map');
				}
			});
		}


		document.addEventListener('DOMContentLoaded', function () {
			// Use event delegation for dynamically generated .fp-tour elements
			document.body.addEventListener('click', function (event) {
				const fpTour = event.target.closest('.fp-tour');

				if (fpTour) {
					const tourUrl = fpTour.getAttribute('data-tour'); // Get the data-tour value
					const iframe = document.querySelector('.tourPopup iframe'); // Select the iframe inside .tourPopup
					const tourPopup = document.querySelector('.tourPopup');

					if (tourUrl && iframe && tourPopup) {
						// Assign the data-tour value to the iframe's src attribute
						iframe.src = tourUrl;

						// Show the popup
						tourPopup.style.display = 'block';
						tourPopup.style.opacity = 1;
					}
				}
			});

			// Close the popup when the close button is clicked
			document.body.addEventListener('click', function (event) {
				if (event.target.closest('.tourPopup .close')) {
					const tourPopup = document.querySelector('.tourPopup');
					const iframe = document.querySelector('.tourPopup iframe');

					if (tourPopup && iframe) {
						tourPopup.style.opacity = 0;

						// Hide the popup after the fade-out effect
						setTimeout(function () {
							tourPopup.style.display = 'none';
							iframe.src = ''; // Clear the iframe src when closing the popup
						}, 500);
					}
				}
			});
		});
	},
};

export default Filters;
